import { kTriangleOffset } from "../constants";

export class QSliderKnob {
  constructor() {
    this.fCurrentPosition = 0;
    this.fLabel = "";
    this.fLabelJust = "center";

    this.fLeftBarrierVal = -1;
    this.fRightBarrierVal = -1;
  }

  SetLabel(theLabel) {
    this.fLabel = theLabel;
  }

  GetLabel() {
    return this.fLabel;
  }

  SetLabelJust(labelJust) {
    this.fLabelJust = labelJust;
  }

  GetLabelJust() {
    return this.fLabelJust;
  }

  SetPosition(position) {
    this.fCurrentPosition = position;
  }

  // Position within the element
  GetPosition() {
    return this.fCurrentPosition;
  }

  // Relative to 0
  GetValue() {
    return this.fCurrentPosition - kTriangleOffset;
  }

  GrabTest(x) {
    var xs = this.fCurrentPosition - kTriangleOffset;
    var xe = this.fCurrentPosition + kTriangleOffset;

    if (x >= xs && x <= xe) return true;
    else return false;
  }

  GetClickOffset(x) {
    var xs = this.fCurrentPosition - kTriangleOffset;
    var xe = this.fCurrentPosition + kTriangleOffset;
    var midP = (xe + xs) / 2 - x;

    return midP;
  }

  SetLeftBarrier(x) {
    this.fLeftBarrierVal = x;
  }

  GetLeftBarrier() {
    return this.fLeftBarrierVal;
  }

  SetRightBarrier(x) {
    this.fRightBarrierVal = x;
  }

  GetRightBarrier() {
    return this.fRightBarrierVal;
  }
}
